<template><li class="uix-list-item"><slot></slot></li></template>
<script>
export default {
}

</script>


// WEBPACK FOOTER //
// ListItem.vue?520450ce